import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { IconButton } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import CancelIcon from '@mui/icons-material/Cancel';

import TituloAdmin from '@components/TituloAdmin';
import BotonBuscar from '@components/BotonBuscar';
import Boton from '@components/Boton';
import LoadingOverlay from '@components/LoadingOverlay';
import LabelCarga from '@components/LabelCarga';
import Notify from '@components/Notify';
import { verCitasExtrasApi, actualizarCitasExtrasApi, crearCitaExtraApi, bulkCreateCitasExtrasApi } from "@api/wp/administracion/citas_extras/citasExtrasApi";
// import { getMedicosProgramacionResumenApi } from "@api/wp/medicos/medicosApi";
// import { getAllMedicosApi } from "@api/wp/medicos/medicosApi";
import { getAllEspecialidadesApi } from "@api/wp/especialidades/especialidadesApi";
import { 
  getSedesBySpecialtyApi,
  getAllSedesApi
} from "@api/wp/sedes/sedesApi";
import { getMedicosBySpecialtyApi } from "@api/wp/medicos/medicosApi";

import { cajaPrincipalStyle } from '@styles/cajaPrincipal';
import { cajaContenedorAdminStyle } from '@styles/cajaContenedorAdmin';

import { tablaEstylos, tablaTheadEstylos, trStyle, thStyle } from '@styles/tablaEstylos';
import { colors } from '@styles/colors';
import Label from '@components/Label';
import { selectStyle } from '@styles/selecsEstylos';
import '@styles/select2Custom.css';
import '@styles/modernTable.css';

import { getAllMedicosApi } from "@api/wp/medicos/medicosApi";

function CitasExtras() {
  const navigate = useNavigate();
  // const [error, setError] = useState(''); // Replaced by Notify
  // const [mensaje, setMensaje] = useState(''); // Replaced by Notify
  const [citasExtras, setCitasExtras] = useState([]);
  // const [resumenMedicos, setResumenMedicos] = useState({ pendientes: 0, programados: 0, numMedicos: 0 });
  const [cargando, setCargando] = useState(false);
  const [procesando, setProcesando] = useState(false);
  
  const [notify, setNotify] = useState({ open: false, message: '', type: 'success' });

  // Estados para el formulario de creación
  const [medicos, setMedicos] = useState([]);
  const [especialidades, setEspecialidades] = useState([]);
  const [sedes, setSedes] = useState([]);
  // const [programarTodosMode, setProgramarTodosMode] = useState(false);
  const [medicoSeleccionado, setMedicoSeleccionado] = useState('');
  const [especialidadSeleccionada, setEspecialidadSeleccionada] = useState('');
  const [sedeSeleccionada, setSedeSeleccionada] = useState('');
  // const [cantidadNueva, setCantidadNueva] = useState('');
  const tablaExtrasRef = useRef(null);
  const [editandoId, setEditandoId] = useState(null);
  const [cantidadEditada, setCantidadEditada] = useState('');
  const [programarTodosData, setProgramarTodosData] = useState([]);
  // Refs para Select2
  const especialidadSelectRef = useRef(null);
  const medicoSelectRef = useRef(null);
  const sedeSelectRef = useRef(null);
  // Estado para marcar filas con cambios pendientes y modo de búsqueda
  const [filasEditadas, setFilasEditadas] = useState({});
  const [modoDoctor, setModoDoctor] = useState(false);
  const [filtrarPorSede, setFiltrarPorSede] = useState(false);

  const handleCloseNotify = () => {
    setNotify({ ...notify, open: false });
  };

  /*
  const handleProgramarTodos = (especialidadId, medicoId) => {
    if (String(especialidadId) === '0' && String(medicoId) === '0') {
      setProgramarTodosMode(true);
    } else {
      setProgramarTodosMode(false);
    }
  };
  */

  useEffect(() => {
    const token = localStorage.getItem('token');
      if (!token) {
        navigate('/login');
      }
    }, [navigate]);

    // Consultar con filtros opcionales (médico, especialidad, sede)
    const consultarCitasExtras = async () => {
      try {
        setCargando(true);
        setModoDoctor(false);
        // setError('');
        // setMensaje('');

        // Validación: Si NO es modo "Filtrar por Sede", requerimos especialidad o sede
        // Si ES modo "Filtrar por Sede", requerimos Sede.
        if (filtrarPorSede) {
             if (!sedeSeleccionada) {
                 setNotify({ open: true, message: 'Seleccione una sede', type: 'error' });
                 setCargando(false);
                 return;
             }
        } else {
             if (!especialidadSeleccionada && !sedeSeleccionada) {
                 setNotify({ open: true, message: 'Seleccione una especialidad o una sede', type: 'error' });
                 setCargando(false);
                 return;
             }
        }

        let medicosList = [];
        let especialidadesList = [];

        if (filtrarPorSede) {
            // Modo "Filtrar por Sede": Ignoramos especialidadSeleccionada (debe estar vacia/deshabilitada)
            // Cargamos TODOS los médicos
            const medicosResp = await getAllMedicosApi();
            medicosList = medicosResp?.result || [];
            especialidadesList = especialidades; // Todas las especialidades
        } else {
             // Modo Normal
             // 1. Determinar lista de médicos y especialidades a procesar
             if (especialidadSeleccionada) {
                  // Caso normal: Especialidad seleccionada -> Cargar médicos de esa especialidad
                  const medicosResp = await getMedicosBySpecialtyApi(especialidadSeleccionada);
                  medicosList = medicosResp?.result || [];
                  // Lista de especialidades es solo la seleccionada
                  const espObj = especialidades.find(e => String(e.id) === String(especialidadSeleccionada));
                  if (espObj) especialidadesList = [espObj];
             } else {
                  // Caso "Todas las especialidades" (pero sin check de filtrarPorSede explicito, aunque logica similar si hay sede)
                  if (sedeSeleccionada) {
                      const medicosResp = await getAllMedicosApi();
                      medicosList = medicosResp?.result || [];
                      especialidadesList = especialidades; 
                  } else {
                      return;
                  }
             }
        }

        // 2. Obtener citas extras existentes
        const filtros = {};
        if (especialidadSeleccionada && !filtrarPorSede) filtros.oid_especialidad = parseInt(especialidadSeleccionada);
        if (sedeSeleccionada) filtros.oid_sede = parseInt(sedeSeleccionada);
        
        const extrasResp = await verCitasExtrasApi(filtros);
        const existingExtras = extrasResp?.result || [];

        // 3. Obtener datos de referencia para mostrar nombres
        const sedeObj = sedeSeleccionada ? sedes.find(s => String(s.id) === String(sedeSeleccionada)) : null;

        // 4. Fusionar listas
        let mergedList = [];
        
        if (sedeSeleccionada) {
            if (especialidadSeleccionada && !filtrarPorSede) {
                // Caso 1: Sede + Especialidad (Modo Normal)
                const espObj = especialidadesList[0];
                mergedList = medicosList.map(medico => {
                    const existing = existingExtras.find(e => e.oid_medico === medico.id);
                    return {
                        id: existing ? existing.id : null, 
                        oid_medico: medico.id,
                        medico: medico.nombre,
                        estado: medico.estado,
                        cantidad: existing ? existing.cantidad : 0,
                        nombre: espObj?.nombre_especialidad || 'N/A',
                        nombre_empresa: espObj?.nombre_empresa || 'N/A',
                        nombre_sede: sedeObj?.nombre_sede || 'N/A',
                        oid_sede: parseInt(sedeSeleccionada),
                        oid_especialidad: parseInt(especialidadSeleccionada)
                    };
                });
            } else {
                // Caso 2: Sede + Todas las Especialidades (Modo Filtrar por Sede o Modo Normal sin Esp)
                // Iteramos TODAS las especialidades válidas para la sede
                
                const especialidadesValidas = [];
                // Optimización: Promise.all para filtrar especialidades que tienen esta sede
                const promesas = especialidades.map(async (esp) => {
                     const resp = await getSedesBySpecialtyApi(esp.id);
                     const sedesDeEsp = resp?.result || resp?.data || [];
                     if (sedesDeEsp.find(s => String(s.id) === String(sedeSeleccionada))) {
                         return esp;
                     }
                     return null;
                });
                
                const resultados = await Promise.all(promesas);
                const especialidadesDeLaSede = resultados.filter(e => e !== null);
                
                if (especialidadesDeLaSede.length === 0) {
                     setNotify({ open: true, message: 'Esta sede no tiene especialidades asociadas.', type: 'warning' });
                }

                // Ahora para estas especialidades, cargamos sus médicos.
                const filasGeneradas = [];
                for (const esp of especialidadesDeLaSede) {
                     const medicosResp = await getMedicosBySpecialtyApi(esp.id);
                     const medicosDeEsp = medicosResp?.result || [];
                     
                     medicosDeEsp.forEach(medico => {
                         const existing = existingExtras.find(e => e.oid_especialidad === esp.id && e.oid_medico === medico.id);
                         filasGeneradas.push({
                            id: existing ? existing.id : null,
                            oid_medico: medico.id,
                            medico: medico.nombre,
                            estado: medico.estado,
                            cantidad: existing ? existing.cantidad : 0,
                            nombre: esp.nombre_especialidad || 'N/A',
                            nombre_empresa: esp.nombre_empresa || 'N/A',
                            nombre_sede: sedeObj?.nombre_sede || 'N/A',
                            oid_sede: parseInt(sedeSeleccionada),
                            oid_especialidad: esp.id
                         });
                     });
                }
                mergedList = filasGeneradas;
            }

        } else {
             // Sin Sede Seleccionada -> No permitido en Modo Filtrar por Sede
             if (filtrarPorSede) {
                 // Should not happen due to validation
             } else {
                  // Modo Normal sin Sede (Solo Esp) -> Filas para todas las sedes
                  // ... (Logica existente)
                  if (especialidadSeleccionada) {
                      const espObj = especialidadesList[0];
                      // Iterar sobre médicos y sedes disponibles
                      if (sedes.length === 0) {
                           const resp = await getSedesBySpecialtyApi(parseInt(especialidadSeleccionada));
                           const lista = resp?.result || resp?.data || [];
                           lista.forEach(sede => {
                                medicosList.forEach(medico => {
                                     const existing = existingExtras.find(e => e.oid_medico === medico.id && e.oid_sede === sede.id);
                                     mergedList.push({
                                        id: existing ? existing.id : null,
                                        oid_medico: medico.id,
                                        medico: medico.nombre,
                                        estado: medico.estado,
                                        cantidad: existing ? existing.cantidad : 0,
                                        nombre: espObj?.nombre_especialidad || 'N/A',
                                        nombre_empresa: espObj?.nombre_empresa || 'N/A',
                                        nombre_sede: sede.nombre_sede || 'N/A',
                                        oid_sede: sede.id,
                                        oid_especialidad: parseInt(especialidadSeleccionada)
                                     });
                                });
                           });
                      } else {
                           sedes.forEach(sede => {
                                medicosList.forEach(medico => {
                                     const existing = existingExtras.find(e => e.oid_medico === medico.id && e.oid_sede === sede.id);
                                     mergedList.push({
                                        id: existing ? existing.id : null,
                                        oid_medico: medico.id,
                                        medico: medico.nombre,
                                        estado: medico.estado,
                                        cantidad: existing ? existing.cantidad : 0,
                                        nombre: espObj?.nombre_especialidad || 'N/A',
                                        nombre_empresa: espObj?.nombre_empresa || 'N/A',
                                        nombre_sede: sede.nombre_sede || 'N/A',
                                        oid_sede: sede.id,
                                        oid_especialidad: parseInt(especialidadSeleccionada)
                                     });
                                });
                           });
                      }
                  }
             }
        }

        setCitasExtras(mergedList);
        setModoDoctor(false);
        setMedicoSeleccionado('');
        // Limpiar select2 de médico visualmente
        const $ = window.$;
        if ($ && medicoSelectRef.current) {
             $(medicoSelectRef.current).val(null).trigger('change');
        }

        setNotify({ open: true, message: 'Datos cargados.', type: 'success' });
      } catch (err) {
        console.error('Error en consulta de citas extras:', err);
        setNotify({ open: true, message: 'Error al consultar las citas extras: ' + (err?.message || ''), type: 'error' });
      } finally {
        setCargando(false);
      }
    };

    // Consultar solo por médico
    const consultarPorMedico = async () => {
      try {
        setCargando(true);
        if (!medicoSeleccionado) {
            setNotify({ open: true, message: 'Seleccione un médico para buscar', type: 'error' });
            setCargando(false);
            return;
        }

        // Obtener citas extras existentes para el médico
        const filtros = { 
            oid_medico: parseInt(medicoSeleccionado)
        };
        const extrasResp = await verCitasExtrasApi(filtros);
        const existingExtras = extrasResp?.result || [];

        setCitasExtras(existingExtras);
        setModoDoctor(true);
        setNotify({ open: true, message: 'Programación del médico cargada.', type: 'success' });
        
        // Limpiar otros filtros visualmente
        const $ = window.$;
        if ($) {
            if (especialidadSelectRef.current) {
                $(especialidadSelectRef.current).val(null).trigger('change');
            }
            if (sedeSelectRef.current) {
                $(sedeSelectRef.current).val(null).trigger('change');
            }
        }
        
      } catch (err) {
        console.error('Error en consulta por médico:', err);
        setNotify({ open: true, message: 'Error al consultar las citas del médico: ' + (err?.message || ''), type: 'error' });
      } finally {
        setCargando(false);
      }
    };

    // Cargar opciones de médicos y especialidades
    const cargarMedicosYEspecialidades = async () => {
      try {
        const [especialidadesResp, medicosResp] = await Promise.all([
          getAllEspecialidadesApi(),
          getAllMedicosApi()
        ]);
        setMedicos(medicosResp?.result || []);
        setEspecialidades(especialidadesResp?.result || []);
        setCargando(false);
      } catch (err) {
        console.error('Error al cargar opciones:', err);
      }
    };

    // Cargar sedes disponibles para la combinación seleccionada de especialidad y médico
    // Modificado: Ahora también carga sedes si solo se selecciona una especialidad, o todas si no hay especialidad
    const cargarSedesDisponibles = async (oid_especialidad) => {
      try {
        setSedes([]);

        // Si el filtro por sede está activado, cargar todas las sedes
        if (filtrarPorSede) {
            // Ya importado arriba: getAllSedesApi
            const resp = await getAllSedesApi();
            const lista = resp?.result || resp?.data || [];
            setSedes(Array.isArray(lista) ? lista : []);
            return;
        }
        
        // Si hay especialidad seleccionada, cargar sus sedes
        if (oid_especialidad) {
          // Cargar sedes relacionadas con la especialidad
          const resp = await getSedesBySpecialtyApi(parseInt(oid_especialidad));
  
          const lista = resp?.result || resp?.data || [];
          setSedes(Array.isArray(lista) ? lista : []);
        } else {
          // Si no hay especialidad (opción "Todas"), cargar TODAS las sedes disponibles
          const resp = await getAllSedesApi();
          const lista = resp?.result || resp?.data || [];
          setSedes(Array.isArray(lista) ? lista : []);
        }
      } catch (err) {
        console.error('Error al cargar sedes disponibles:', err);
        setSedes([]);
      }
    };

    // Función para cambiar el valor de cantidad
    const cambiarValor = (index, nuevoValor) => {
      const nuevasCitasExtras = [...citasExtras];
      nuevasCitasExtras[index] = {
        ...nuevasCitasExtras[index],
        cantidad: parseInt(nuevoValor) || 0
      };
      setCitasExtras(nuevasCitasExtras);
      setFilasEditadas(prev => ({ ...prev, [index]: true }));
    };

    // Handlers de edición en tabla
    // Guardar cantidad para una fila específica (usa el valor del estado de la tabla)
    // Removed guardarCantidadFila as per user request to remove actions column

    // Guardar cantidad para una fila específica usando su ID (OK por fila)
    const guardarCantidadFila = async (index) => {
      try {
        const fila = citasExtras[index];
        if (!fila || !fila.id) {
          setNotify({ open: true, message: 'No se puede actualizar: registro sin ID.', type: 'error' });
          return;
        }
        const cantidad = parseInt(fila.cantidad) || 0;
        await actualizarCitasExtrasApi(fila.id, cantidad);
        setNotify({ open: true, message: 'Cantidad actualizada correctamente.', type: 'success' });
        // Marcar fila como guardada
        setFilasEditadas(prev => ({ ...prev, [index]: false }));
        // Refrescar datos según el modo actual
        if (modoDoctor) {
          await consultarPorMedico();
        } else {
          await consultarCitasExtras();
        }
      } catch (error) {
        console.error('Error al actualizar cantidad por fila:', error);
        setNotify({ open: true, message: 'Error al actualizar cantidad: ' + (error?.message || ''), type: 'error' });
      }
    };

    // Función para confirmar todos los cambios
    const confirmarCambios = async () => {
      try {
        // Mostrar mensaje de carga
        // alert('Guardando cambios...');

        // Actualizar cada registro que tenga cambios
        const promesasActualizacion = citasExtras.map(async (citaExtra) => {
          try {
            const response = await actualizarCitasExtrasApi(citaExtra.id, citaExtra.cantidad);
            return { id: citaExtra.id, success: true, response };
          } catch (error) {
            console.error(`Error al actualizar registro ${citaExtra.id}:`, error);
            return { id: citaExtra.id, success: false, error };
          }
        });

        // Esperar a que todas las actualizaciones se completen
        const resultados = await Promise.all(promesasActualizacion);

        // Verificar si todas las actualizaciones fueron exitosas
        const errores = resultados.filter(resultado => !resultado.success);

        if (errores.length === 0) {
          setNotify({ open: true, message: '¡Todos los cambios se guardaron exitosamente!', type: 'success' });
          // Recargar los datos para mostrar los valores actualizados
          await consultarCitasExtras(); // Changed from cargarCitasExtras to consultarCitasExtras which seems to be the one used
        } else {
          setNotify({ open: true, message: `Se guardaron ${resultados.length - errores.length} de ${resultados.length} registros. Algunos registros no se pudieron actualizar.`, type: 'warning' });
          console.error('Errores en actualización:', errores);
        }

        // Desactivar cualquier edición activa
        //setEditandoIndex(null);

      } catch (error) {
        console.error('Error general al confirmar cambios:', error);
        setNotify({ open: true, message: 'Error al guardar los cambios. Por favor, inténtelo de nuevo.', type: 'error' });
      }
    };

    useEffect(() => {
      // cargarCitasExtras(); // Removed initial load
      cargarMedicosYEspecialidades();
    }, []);

    // Efecto para manejar el cambio de modo "Filtrar por Sede"
    useEffect(() => {
        const resetFilters = async () => {
             // Limpiar especialidad
             setEspecialidadSeleccionada('');
             const $ = window.$;
             if ($ && especialidadSelectRef.current) {
                 $(especialidadSelectRef.current).val(null).trigger('change');
             }
             
             // Cargar sedes (todas si está activo el filtro, o limpiar si no)
             // Si desactivamos el filtro, volvemos al estado base (sin especialidad seleccionada -> todas las sedes o vacio?)
             // Al desactivar, si no hay especialidad, cargamos todas las sedes por defecto (como hicimos antes para "Todas")
             // Pero lo importante es refrescar la lista de sedes
             await cargarSedesDisponibles('');
        };
        resetFilters();
    }, [filtrarPorSede]);

    // Cuando se seleccionan especialidad y médico, cargar sedes disponibles
    useEffect(() => {
      if (especialidadSeleccionada) {
        cargarSedesDisponibles(especialidadSeleccionada);
      } else {
        setSedes([]);
        setSedeSeleccionada('');
        // resumenProgrma()
      }
    }, [especialidadSeleccionada]);
    /*
    const resumenProgrma = async () => {
      // En paralelo: cargar resumen de médicos
      try {
        const r = await getMedicosProgramacionResumenApi();
        console.log('r', r)
        const pendientes = Number(r?.result?.pendientes || 0);
        const programados = Number(r?.result?.programados || 0);
        const numMedicos = Number(r?.num?.medicos || (pendientes + programados));
        setResumenMedicos({ pendientes, programados, numMedicos });
      } catch (_e) {
        // No bloquear la consulta principal por error en resumen
      }
    }
    */
    // Inicializar Select2 en Especialidades cuando cambian las opciones
    useEffect(() => {
      try {
        const $ = window.$;
        if (!especialidadSelectRef.current || !$ || !$.fn || !$.fn.select2) {
          return;
        }
        const $el = $(especialidadSelectRef.current);
        // Destruir instancia previa si existe
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }

        $el.select2({
          placeholder: '-- Seleccione una especialidad --',
          allowClear: true,
          width: '100%',
          theme: 'default',
          minimumResultsForSearch: 0,
          language: {
            noResults: function () { return 'No se encontraron resultados'; },
            searching: function () { return 'Buscando...'; }
          }
        });

        // Enlazar cambios al estado
        $el.on('change.select2react', function () {
          const value = $el.val() || '';
          setEspecialidadSeleccionada(value);
        });

        // Aplicar valor inicial si existe
        if (especialidadSeleccionada) {
          $el.val(String(especialidadSeleccionada)).trigger('change');
        }

        // Cleanup
        return () => {
          if ($el.hasClass('select2-hidden-accessible')) {
            $el.off('change.select2react');
            $el.select2('destroy');
          }
        };
      } catch (e) {
        console.error('Error inicializando Select2 (especialidades):', e);
      }
    }, [especialidades]);

    // Inicializar Select2 en Sedes cuando cambian las opciones
    useEffect(() => {
      try {
        const $ = window.$;
        if (!sedeSelectRef.current || !$ || !$.fn || !$.fn.select2) {
          return;
        }
        const $el = $(sedeSelectRef.current);
        // Destruir instancia previa si existe
        if ($el.hasClass('select2-hidden-accessible')) {
          $el.off('change.select2react');
          $el.select2('destroy');
        }

        $el.select2({
          placeholder: '-- Todas las sedes --',
          allowClear: true,
          width: '100%',
          theme: 'default',
          minimumResultsForSearch: 0,
          language: {
            noResults: function () { return 'No se encontraron resultados'; },
            searching: function () { return 'Buscando...'; }
          }
        });

        // Enlazar cambios al estado
        $el.on('change.select2react', function () {
          const value = $el.val() || '';
          setSedeSeleccionada(value);
        });

        // Aplicar valor inicial si existe
        if (sedeSeleccionada) {
          $el.val(String(sedeSeleccionada)).trigger('change');
        }

        // Cleanup
        return () => {
          if ($el.hasClass('select2-hidden-accessible')) {
            $el.off('change.select2react');
            $el.select2('destroy');
          }
        };
      } catch (e) {
        console.error('Error inicializando Select2 (sedes):', e);
      }
    }, [sedes]);

    // Inicializar Select2 en Médicos
    useEffect(() => {
        try {
          const $ = window.$;
          if (!medicoSelectRef.current || !$ || !$.fn || !$.fn.select2) {
            return;
          }
          const $el = $(medicoSelectRef.current);
          if ($el.hasClass('select2-hidden-accessible')) {
            $el.off('change.select2react');
            $el.select2('destroy');
          }
  
          $el.select2({
            placeholder: '-- Buscar por Médico (Opcional) --',
            allowClear: true,
            width: '100%',
            theme: 'default',
            minimumResultsForSearch: 0,
            language: {
              noResults: function () { return 'No se encontraron resultados'; },
              searching: function () { return 'Buscando...'; }
            }
          });
  
          $el.on('change.select2react', function () {
            const value = $el.val() || '';
            setMedicoSeleccionado(value);
          });
  
          if (medicoSeleccionado) {
            $el.val(String(medicoSeleccionado)).trigger('change');
          }
  
          return () => {
            if ($el.hasClass('select2-hidden-accessible')) {
              $el.off('change.select2react');
              $el.select2('destroy');
            }
          };
        } catch (e) {
          console.error('Error inicializando Select2 (médicos):', e);
        }
      }, [medicos]);

    // Exportar contenido de la tabla a Excel (CSV compatible)
    const descargarExcel = () => {
      try {
        const headers = ['Especialidad', 'Empresa', 'Médico', 'Sede', 'Citas extras'];
        const datos = Array.isArray(citasExtras) ? citasExtras : [];

        const filas = datos.map((item) => [
          item?.nombre ?? 'N/A',
          item?.nombre_empresa ?? 'N/A',
          item?.medico ?? 'N/A',
          item?.nombre_sede ?? 'N/A',
          item?.cantidad ?? 0
        ]);

        const sep = ';'; // separador recomendado para Excel en configuración regional ES
        const esc = (val) => {
          const s = String(val).replace(/"/g, '""');
          return `"${s}"`;
        };

        let contenido = '\uFEFF'; // BOM para UTF-8, mejora compatibilidad con Excel
        contenido += headers.map(esc).join(sep) + '\r\n';
        for (const fila of filas) {
          contenido += fila.map(esc).join(sep) + '\r\n';
        }

        const blob = new Blob([contenido], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        const fecha = new Date().toISOString().slice(0, 10);
        a.href = url;
        a.download = `citas_extras_${fecha}.csv`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
      } catch (e) {
        console.error('Error al exportar Excel (CSV):', e);
        setNotify({ open: true, message: 'No se pudo generar el archivo. Inténtalo de nuevo.', type: 'error' });
      }
    };

    const guardarProgramacion = async () => {
      try {
        setProcesando(true);

        if (!medicoSeleccionado && !especialidadSeleccionada) {
            setNotify({ open: true, message: 'Faltan datos de especialidad o médico seleccionado', type: 'error' });
            setProcesando(false);
            return;
        }
        
        // Intentar obtener idEsp de la especialidad seleccionada si existe
        let idEspGlobal = null;
        if (especialidadSeleccionada) {
            const espSel = especialidades.find(
                (e) => String(e.id) === String(especialidadSeleccionada)
            );
            idEspGlobal = espSel?.id;
        }

        const dataToSave = citasExtras.map(item => {
            // Determinar idEsp: prioridad al del item (si viene de BD), sino el global
            const idEspItem = item.idEsp ? parseInt(item.idEsp) : (idEspGlobal ? parseInt(idEspGlobal) : null);
            
            return {
                oid_especialidad: item.oid_especialidad || parseInt(especialidadSeleccionada),
                oid_medico: item.oid_medico || parseInt(medicoSeleccionado), 
                cantidad: parseInt(item.cantidad) || 0,
                idEsp: idEspItem,
                oid_sede: item.oid_sede // Ya no dependemos de sedeSeleccionada como fallback global, usamos el del item
            };
        });

        // Validar que tengamos idEsp para todos los registros que vamos a guardar (especialmente nuevos)
        // Nota: Para updates de registros existentes, el backend podría no requerir idEsp si usa el ID del registro, 
        // pero bulkCreate usa (oid_especialidad, oid_medico, oid_sede) para buscar existencia.
        // Si es INSERT, idEsp es obligatorio.
        const invalidos = dataToSave.filter(d => !d.idEsp && !d.oid_especialidad); // Si falta idEsp y oid_especialidad es critico. 
        // Realmente si falta idEsp es problemático para inserts.

        if (dataToSave.length === 0) {
            setNotify({ open: true, message: 'No hay datos para guardar', type: 'error' });
            setProcesando(false);
            return;
        }

        await bulkCreateCitasExtrasApi(dataToSave);
        setNotify({ open: true, message: 'Programación guardada correctamente', type: 'success' });
        await consultarCitasExtras();

      } catch (err) {
        console.error('Error al guardar programación:', err);
        setNotify({ open: true, message: 'Error: ' + (err?.message || ''), type: 'error' });
      } finally {
        setProcesando(false);
      }
    };

    // Tabla normal: React maneja inputs y botón de actualizar por fila

    return (
      <div id="cajaPrincipal" style={cajaPrincipalStyle}>
        <LoadingOverlay visible={cargando || procesando} />
        <Notify
          open={notify.open}
          message={notify.message}
          type={notify.type}
          onClose={handleCloseNotify}
        />
        <TituloAdmin
          titulo="Gestión Citas Extras"
          imagen_titulo="extras"
          subtitulo="Gestión y visualización de la programación extra de citas médicas"
        />

        {/* Div central */}
        <div style={cajaContenedorAdminStyle}>

          {/* Mensajes de estado eliminados (usando Notify) */}
          
          {/* Formulario de creación */}
          <div style={{ marginTop: '0vh', width: '100%' }}>

            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-end',
              marginBottom: '2.5vh',
              gap: '2vh'
            }}>
              
              {/* Grupo Izquierdo: Filtros Especialidad y Sede */}
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '2vh', flex: 1 }}>
                  <div style={{ }}>
                    <Label>Filtrar por Sede</Label>
                    <div style={{ display: 'flex', alignItems: 'center', height: '5vh' }}>
                        <input
                            type="checkbox"
                            checked={filtrarPorSede}
                            onChange={(e) => setFiltrarPorSede(e.target.checked)}
                            style={{ width: '2vh', height: '2vh', cursor: 'pointer' }}
                        />
                        <span style={{ marginLeft: '1vh', fontSize: '1.4vh', fontFamily: 'Inter' }}>
                            {filtrarPorSede ? 'Activado' : 'Desactivado'}
                        </span>
                    </div>
                  </div>

                  <div style={{ flex: 1 }}>
                    <Label>Seleccionar especialidad:</Label>
                    <select
                      ref={especialidadSelectRef}
                      value={especialidadSeleccionada}
                      onChange={(e) => {
                        const newEspecialidad = e.target.value;
                        setEspecialidadSeleccionada(newEspecialidad);
                        // handleProgramarTodos(newEspecialidad, medicoSeleccionado);
                      }}
                      style={selectStyle}
                      disabled={cargando || procesando || filtrarPorSede}
                      onFocus={(e) => e.target.style.borderColor = colors.primary}
                      onBlur={(e) => e.target.style.borderColor = colors.gray200}
                    >
                      <option value="">{filtrarPorSede ? '-- Deshabilitado --' : '-- Seleccione una especialidad --'}</option>
                      {especialidades.map((esp) => (
                        <option key={esp.id} value={esp.id}>
                          {esp.nombre_especialidad} - {esp.nombre_empresa}
                        </option>
                      ))}
                    </select>
                  </div>

                  <div style={{ flex: 1 }}>
                    <Label>Seleccionar Sede:</Label>
                    <select
                      ref={sedeSelectRef}
                      value={sedeSeleccionada}
                      onChange={(e) => setSedeSeleccionada(e.target.value)}
                      style={selectStyle}
                      disabled={cargando || procesando || (!especialidadSeleccionada && !filtrarPorSede) || sedes.length === 0}
                      onFocus={(e) => e.target.style.borderColor = colors.primary}
                      onBlur={(e) => e.target.style.borderColor = colors.gray200}
                    >
                      <option value="">-- Todas las sedes --</option>
                      {sedes.map((sede) => (
                        <option key={sede.id} value={sede.id}>
                          {sede.nombre_sede}
                        </option>
                      ))}
                    </select>
                  </div>

                  <BotonBuscar
                    onClick={consultarCitasExtras}
                    disabled={cargando || procesando}
                    titulo="Consultar citas extras por especialidad y sede"
                    varianteFiltros={false}
                  />
              </div>

              {/* Grupo Derecho: Buscar por Médico */}
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: '1vh', width: '30%' }}>
                <div style={{ flex: 1 }}>
                  <Label>Buscar por Médico:</Label>
                  <select
                    ref={medicoSelectRef}
                    value={medicoSeleccionado}
                    onChange={(e) => setMedicoSeleccionado(e.target.value)}
                    style={selectStyle}
                    disabled={cargando || procesando}
                  >
                    <option value="">-- Buscar por Médico --</option>
                    {medicos.map((m) => (
                      <option key={m.id} value={m.id}>
                        {m.nombre}
                      </option>
                    ))}
                  </select>
                </div>
                <BotonBuscar
                  onClick={consultarPorMedico}
                  disabled={cargando || procesando}
                  titulo="Consultar citas extras por médico seleccionado"
                  varianteFiltros={false}
                />
              </div>
            </div>

            {/* Formulario de creación eliminado (inputs de cantidad y botón) */}
          </div>

          {/* Lista de relaciones existentes (debajo del formulario) */}
          <div style={{ width: '100%', marginTop: '3vh' }}>
            {cargando ? (
              <LabelCarga nombre="citas extras" />
            ) : (
            <div className="modern-table-container">
              <table ref={tablaExtrasRef} id="tabla-citas-extras" className="modern-table">
                <thead>
                  <tr>
                    <th>Especialidad - Empresa</th>
                    <th>Médico</th>
                    <th>Sede</th>
                    <th>Citas extras</th>
                  </tr>
                </thead>
                <tbody>
                  {!cargando && Array.isArray(citasExtras) && citasExtras.map((citaExtra, index) => (
                    <tr key={citaExtra.id ?? index}>
                      <td>{citaExtra.nombre || 'N/A'} - {citaExtra.nombre_empresa || 'N/A'}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1vh' }}>
                          {citaExtra.medico || 'N/A'}
                          {citaExtra.estado === 1 && (
                            <div style={{ display: 'flex', alignItems: 'center', color: colors.errorText, gap: '0.5vh' }}>
                              <CancelIcon style={{ fontSize: '2vh' }} />
                              <span style={{ fontSize: '1.6vh', fontWeight: 600 }}>Inactivo</span>
                            </div>
                          )}
                        </div>
                      </td>
                      <td>{citaExtra.nombre_sede || 'N/A'}</td>
                      <td>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '1vh' }}>
                          <input
                            type="number"
                            min="0"
                            value={citaExtra.cantidad || 0}
                            onChange={(e) => cambiarValor(index, e.target.value)}
                            style={{
                              width: '80px',
                              height: '3.5vh',
                              padding: '0.3rem 0.5rem',
                              border: `1px solid ${colors.gray200}`,
                              borderRadius: '4px',
                              fontSize: '1.8vh',
                              fontFamily: 'Inter',
                              textAlign: 'center',
                              fontWeight: '600',
                              backgroundColor: colors.white
                            }}
                          />
                          {citaExtra.id && filasEditadas[index] && (
                            <IconButton
                              onClick={() => guardarCantidadFila(index)}
                              title="Guardar cantidad"
                              style={{
                                backgroundColor: colors.primary,
                                color: 'white',
                                borderRadius: '8px',
                                height: '4vh',
                                width: '4vh',
                              }}
                            >
                              <CheckIcon />
                            </IconButton>
                          )}
                        </div>
                      </td>
                    </tr>
                ))}
              </tbody>
              </table>
              {/* Tabla normal: sin contenedor de botones DataTables */}
            </div>
            )}
            {/* Botón para descargar el contenido de la tabla a Excel */}
          <div style={{ textAlign: 'right', marginTop: '1.5vh', display: 'flex', justifyContent: 'flex-end', gap: '2vh' }}>
            <Boton
              label={"Guardar Programación"}
              onClick={guardarProgramacion}
              disabled={procesando || cargando || !Array.isArray(citasExtras) || citasExtras.length === 0}
              color={colors.accent}
              ancho="25vh"
              alto="5vh"
            />
            <Boton
              label={"Descargar Excel"}
              onClick={descargarExcel}
              disabled={cargando || !Array.isArray(citasExtras) || citasExtras.length === 0}
              color={colors.primary}
              ancho="25vh"
              alto="5vh"
            />
          </div>
        </div>


        {/* Botón de actualizar eliminado */}
      </div>
    </div>
  );
}

export default CitasExtras;

